module.exports = ".follow{\n    background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../assets/icons/new/LIKE.svg) center center no-repeat;\n    \n}\n\n.unfollow{\n    background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../assets/icons/new/LIKE_BLACK.svg) center center no-repeat;\n    color:black;\n    \n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-discoveries/follow/follow.component.css
// module id = ./src/app/my-discoveries/follow/follow.component.css
// module chunks = main